export enum NewsAndUpdatesMenuType {
    CheckBox,
    RadioButton,
}